module.exports = __webpack_public_path__ + "img/slack.3b4a3240.svg";